// This is the default item spacing in EmblaCarousel
var DEFAULT_SPACING = 16;
export var getSpacingPixels = function(spacing) {
    var _spacingToNumberMap_spacing;
    return (_spacingToNumberMap_spacing = spacingToNumberMap[spacing]) !== null && _spacingToNumberMap_spacing !== void 0 ? _spacingToNumberMap_spacing : DEFAULT_SPACING;
};
// Spacing values come from https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Faire-Slate?type=design&node-id=4449-12646&mode=design&t=crJA1bdzBVGLE3uu-0
var spacingToNumberMap = {
    L: 24,
    R: 16,
    S: 12,
    XS: 8,
    XXS: 4,
    SPACING_NONE: 0,
    SPACING_UNKNOWN: DEFAULT_SPACING
};
